import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective, ToastService, TabsetComponent } from 'ng-uikit-pro-standard';
import { SecurityService } from 'src/app/shared/services/security.service';
import { debounceTime, filter } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ModalSeleccionarVendedorComponent } from 'src/app/views/shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import { ClienteProveedorService } from '../../../../services/cliente-proveedor.service';

@Component({
  selector: 'app-traspaso-masivo-modal-generar-ipt',
  templateUrl: './modal-generar-ipt.component.html',
  styleUrls: ['../traspaso-masivo-cliente.component.scss'],
  providers: [SecurityService]
})
export class ModalGenerarIptComponent implements OnInit {

  // Modales
  @ViewChild('generarIPT', { static: true }) modalGenerarIPT: ModalDirective;
  @ViewChild(ModalSeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: ModalSeleccionarVendedorComponent
  @ViewChild('staticTabs', { static: true }) staticTabs: TabsetComponent;


  @Input() enviarClientesSelecc: any; //Clientes recibidos cuando son seleccionados en vista principal
  @Input() enviarRutVendedor: string;

  @Output() EnviarInfo = new EventEmitter<any>(); //actualizar grilla principal

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  private usuarioDeclaracionRut: number
  private vendedorCodigo: number
  vendedorSeleccionado: any = null

  // Utils
  private log: any
  diasSemana: any;
  selecClientes: any;
  listaClientes: any;


  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    public rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private clienteProveedorService: ClienteProveedorService,
  ) {
    this.log = this.clog.log('TRAPASO-MASIVO-CLIENTES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.createForms();
    this.formChangesSubscriptions()
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rutVendedor: [null, Validators.required]
    });
  }

  private formChangesSubscriptions() {

    this.formHeader.get("rutVendedor").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutVendedor: string) => {
        this.modalSeleccionarVendedor.searchByRut(rutVendedor)
      })

  }

  onChangeL(event, index, item) {

    item.lunes = !item.lunes;
    if (item.lunes === true) {
      this.listaClientes.forEach(x => {
        if (x.rut === item.rut && item.lunes) {
          x.lunes = true;
        }
      })
    }

  }

  onChangeM(event, index, item) {
    item.martes = !item.martes;
    if (item.martes === true) {
      this.listaClientes.forEach(x => {
        if (x.rut === item.rut && item.martes) {
          x.martes = true;
        }
      })
    }



  }
  onChangeMi(event, index, item) {

    item.miercoles = !item.miercoles;
    if (item.miercoles === true) {
      this.listaClientes.forEach(x => {
        if (x.rut === item.rut && item.miercoles) {
          x.miercoles = true;
        }
      })
    }



  }
  onChangeJ(event, index, item) {

    item.jueves = !item.jueves;
    if (item.jueves === true) {
      this.listaClientes.forEach(x => {
        if (x.rut === item.rut && item.jueves) {
          x.jueves = true;
        }
      })
    }


  }

  onChangeV(event, index, item) {

    item.viernes = !item.viernes;
    if (item.viernes === true) {
      this.listaClientes.forEach(x => {
        if (x.rut === item.rut && item.viernes) {
          x.viernes = true;
        }
      })
    }

  }

  onChangeS(event, index, item) {

    item.sabado = !item.sabado;
    if (item.sabado === true) {
      this.listaClientes.forEach(x => {
        if (x.rut === item.rut && item.martes) {
          x.martes = true;
        }
      })
    }

  }

  onChangeD(event, index, item) {

    item.domingo = !item.domingo;
    if (item.domingo === true) {
      this.listaClientes.forEach(x => {
        if (x.rut === item.rut && item.domingo) {
          x.domingo = true;
        }
      })
    }

  }

  load(rutseleccionadoVendedor) {
    this.show()
    this.listaClientes = this.enviarClientesSelecc; // carga de datos del view traspaso-masivo

    this.formHeader.get('rutVendedor').setValue(rutseleccionadoVendedor)

    //** DESHABILITAR TABS MANUAL CUANDO NO HAYAN CLIENTES SELECCIONADOS */
    if (this.listaClientes.length === 0) {
      this.staticTabs.tabs[1].disabled = true
    } else {
      this.staticTabs.tabs[1].disabled = false
    }
  }
  /********* MODAL VENDEDOR *********/
  openModalSeleccionarVendedor() {
    this.modalSeleccionarVendedor.show()
  }

  onVendedorSeleccionado({ data }) {
    this.vendedorSeleccionado = data
    this.formHeader.get('rutVendedor').setValue(this.rutService.AgregarDV(this.vendedorSeleccionado.rut))
    this.vendedorCodigo = this.vendedorSeleccionado.codigo
  }

  onVendedorNoEncontrado() {
    this.vendedorSeleccionado = null
  }
  /********* MODAL VENDEDOR *********/

  show() {
    this.modalGenerarIPT.show()
  }

  receiveMessage($event) {
    this.diasSemana = $event
  }

  generarIPTVendedor() {
    this.log('Vendedor Codigo ', JSON.stringify(this.vendedorCodigo))
    //* TAB EN AUTOMATICO
    if (this.staticTabs.tabs[0].heading && this.staticTabs.tabs[0].active === true) {

      const DatosIPTAUTO = this.enviarClientesSelecc.map(clientes => {
        const paramsClientes = {
          cliente_proveedor_rut: clientes.rut,
          direccion_codigo: clientes.codigo_direccion,
        }
        return paramsClientes
      })
      const ParamsAuto = {
        entidad: {
          empresa_rut: this.rutEmpresa,
          vendedor_codigo: this.vendedorCodigo,
          lunes: Boolean(this.diasSemana[0].checked),    //lunes
          martes: Boolean(this.diasSemana[1].checked),   //martes
          miercoles: Boolean(this.diasSemana[2].checked), //miercoles
          jueves: Boolean(this.diasSemana[3].checked),    //jueves
          viernes: Boolean(this.diasSemana[4].checked),   //viernes
          sabado: Boolean(this.diasSemana[5].checked),    //sabado
          domingo: Boolean(this.diasSemana[6].checked)   //domingo
        },
        clientes: DatosIPTAUTO
      }

      this.log('ParamsAuto', JSON.stringify(ParamsAuto))

      this.clienteProveedorService.generarIPTVendedorAuto(ParamsAuto, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        this.modalGenerarIPT.hide()
        this.EnviarInfo.emit()
        this.toastrService.success('Operación exitosa')
      })

    }

    //* TAB EN MANUAL
    if (this.staticTabs.tabs[1].heading && this.staticTabs.tabs[1].active === true) {
      const DatosIPTMANUAL = this.listaClientes.map(clientes => {
        const paramsClientes = {
          cliente_proveedor_rut: clientes.rut,
          direccion_codigo: clientes.codigo_direccion,
          lunes: clientes.lunes,
          martes: clientes.martes,
          miercoles: clientes.miercoles,
          jueves: clientes.jueves,
          viernes: clientes.viernes,
          sabado: clientes.sabado,
          domingo: clientes.domingo

        }
        return paramsClientes
      })

      const ParamsManual = {
        entidad: {
          empresa_rut: this.rutEmpresa,
          vendedor_codigo: this.vendedorCodigo
        },
        clientes: DatosIPTMANUAL

      }

      this.log('ParamsManual', JSON.stringify(ParamsManual))

      this.clienteProveedorService.generarIPTVendedorManual(ParamsManual, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        this.modalGenerarIPT.hide()
        this.EnviarInfo.emit()
        this.toastrService.success('Operación exitosa')
      })
    }
  }

}
